<div *ngIf="labelsInitialized" class="flight-status-container">
    <adc-grid class="grid-container" form="true">
        <adc-loading *ngIf="showLoading" state="active" attr.label-text="{{ 'global.loading'| aai18n }}"></adc-loading>
        <adc-row>
            <adc-column col-desktop="12" col-tablet="12" col-phone="4">
                <div class="switcher-label">{{'flightStatus.searchBy' | aai18n}}:</div>
                <adc-content-switcher id="contentSwitcher" selected="flightNumber" class="switcher-container">
                    <div class="switch-tab-container">
                        <adc-content-switch value="flightNumber" id="flight-number-tab" class="switch-content">{{ 'flightStatus.flightNumber' | aai18n }}</adc-content-switch>
                        <adc-content-switch value="cities" id="city-tab" class="switch-content">{{ 'flightStatus.cities' | aai18n }}</adc-content-switch>
                    </div>
                    <adc-content-switch-panel value="cities" class="switch-panel">
                        <hp-cities [loadingState]="showLoading" (loadingStateChanged)="loadingChangedHandler($event)"></hp-cities>
                    </adc-content-switch-panel>
                    <adc-content-switch-panel value="flightNumber" class="switch-panel">
                        <hp-flight-number [loadingState]="showLoading" (loadingStateChanged)="loadingChangedHandler($event)"></hp-flight-number>
                    </adc-content-switch-panel>
                </adc-content-switcher>
            </adc-column>
        </adc-row>
        <div>
            <adc-link href="/travelInformation/flights/schedule" icon="chevron" data-cy="notification-link">{{ 'flightStatus.notificationLinkText' | aai18n }}</adc-link>
        </div>
    </adc-grid>
</div>
